import { Box, Stack, Tooltip } from '@mui/material';
import CameraDownloadIcon, { DownloadButtonState } from './CameraDownloadIcon';

type Props = {
  camera: string;
  sx?: object;
  /** Icon state, resolved by the clip group (see useClipDownloadFeedback). */
  downloadState: DownloadButtonState;
  disabled?: boolean;
  onClick?: () => void;
  onDownloadClick?: () => void;
};

export const CameraButton: React.FC<Props> = ({
  camera,
  sx,
  downloadState,
  onClick,
  disabled = false,
  onDownloadClick,
}) => {
  const handleClick = () => {
    if (onClick && !disabled) {
      onClick();
    }
  };

  const cameraButton = (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'left',
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default',
        // Every reachable button reads at full strength (Figma "Clip download
        // states"): the circle colour alone carries the state. Only a camera
        // that is not live is dimmed.
        opacity: disabled ? 0.4 : 1,
        transition: 'opacity 0.2s',
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        // Allow download when in 'ready' (checkmark) or 'download' (arrow) state
        if (onDownloadClick && (downloadState === 'ready' || downloadState === 'download')) {
          onDownloadClick();
        } else {
          handleClick();
        }
      }}
    >
      <Box>
        <CameraDownloadIcon state={downloadState} size="medium" />
      </Box>
      <Box
        sx={{
          ml: 0.75,
          whiteSpace: 'nowrap',
          ...sx,
        }}
      >
        {camera.replace('Left', 'L').replace('Right', 'R')}
      </Box>
    </Stack>
  );

  if (disabled) {
    return (
      <Tooltip title="Disabled" arrow placement="top">
        <span style={{ display: 'inline-block' }}>{cameraButton}</span>
      </Tooltip>
    );
  }

  return cameraButton;
};

export default CameraButton;
